import { useState } from 'react';
import { Plus, ChevronDown, ChevronRight } from 'lucide-react';

/**
 * Collapsible tags section in the sidebar.
 */
export default function SidebarTagList({
  tags, noteCountByTag, filterTagId, handleNavClick, onAddTag,
}) {
  const [open, setOpen] = useState(true);

  return (
    <div className="pt-4">
      <div className="flex items-center gap-1.5 px-3 py-2 w-full min-h-[36px] cursor-pointer hover:bg-muted/30">
        <button onClick={() => setOpen(!open)} className="flex items-center gap-1.5 flex-1" data-testid="sidebar-tags-toggle">
          {open ? <ChevronDown className="w-3.5 h-3.5" /> : <ChevronRight className="w-3.5 h-3.5" />}
          <span className="text-xs uppercase tracking-[0.1em] text-muted-foreground font-medium">Tags</span>
        </button>
        <button onClick={(e) => { e.stopPropagation(); onAddTag(); }} className="p-1.5 -mr-1 text-muted-foreground hover:text-foreground active:text-foreground" data-testid="sidebar-add-tag-btn">
          <Plus className="w-4 h-4" />
        </button>
      </div>
      {open && (
        <div className="mt-0.5 space-y-0.5">
          {tags.map((tag) => (
            <button
              key={tag.id}
              onClick={() => handleNavClick('all', null, tag.id)}
              data-testid={`sidebar-tag-${tag.id}`}
              className={`w-full flex items-center gap-3 min-h-[44px] py-2.5 px-3 rounded-sm text-sm transition-colors ${
                filterTagId === tag.id
                  ? 'bg-muted text-foreground'
                  : 'text-muted-foreground hover:bg-muted/50 hover:text-foreground active:bg-muted/70'
              }`}
            >
              <span className="w-3 h-3 rounded-full flex-shrink-0" style={{ backgroundColor: tag.color }} />
              <span className="truncate flex-1 text-left">{tag.name}</span>
              <span className="text-xs text-muted-foreground">{noteCountByTag[tag.id] || 0}</span>
            </button>
          ))}
          {tags.length === 0 && (
            <p className="text-xs text-muted-foreground/50 px-3 py-2">No tags yet</p>
          )}
        </div>
      )}
    </div>
  );
}
